import { getValidationResolver, useForm } from '@common-fe/common-fe';
import * as yup from 'yup';

import { VALIDATORS } from '@/common';
import { AUTH_ERROR_KEY } from '@/common/constants';

export enum ResetPasswordField {
  newPassword = 'newPassword',
  confirmNewPassword = 'confirmNewPassword',
}

export interface ResetPasswordForm {
  [ResetPasswordField.newPassword]: string;
  [ResetPasswordField.confirmNewPassword]: string;
}

const useResetPasswordForm = () => {
  const methods = useForm<ResetPasswordForm>({
    resolver: getValidationResolver({
      [ResetPasswordField.newPassword]: VALIDATORS.PASSWORD,
      [ResetPasswordField.confirmNewPassword]: yup.string()
        .required(AUTH_ERROR_KEY.PASSWORD_IS_REQUIRED)
        .oneOf([yup.ref(ResetPasswordField.newPassword)], AUTH_ERROR_KEY.PASSWORD_DO_NOT_MATCH),
    })
  });

  return { methods };
};

export default useResetPasswordForm;
